import React, { useState } from "react";
import Hero from "../components/hero/Hero";
import Footer from "../components/footer/Footer";
import mobileHero from "../assets/images/mobileHero.png";
import notes from "../assets/images/notes.png";
import cup from "../assets/images/cup.png";
import globe from "../assets/images/globe.png";
import privy from "../assets/images/privy.png";
import iak from "../assets/images/iak.png";
import verihub from "../assets/images/verihub.png";
import { FaClock, FaHandHoldingUsd, FaLightbulb } from "react-icons/fa";

const HomePage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const mitraLogos = [privy, iak, verihub];

  const whyChooseUs = [
    {
      title: "Satu Platform, Semua Solusi",
      desc: "Di Tomi, Anda bisa menemukan berbagai produk keuangan pinjaman, asuransi, investasi, dalam satu tempat yang mudah digunakan.",
      icon: <FaClock className="text-white text-4xl mb-4" />,
    },
    {
      title: "Cocok Sesuai Kebutuhan Anda",
      desc: "Platform kami dilengkapi dengan teknologi cerdas yang menyesuaikan rekomendasi layanan berdasarkan kebutuhan dan profil Anda.",
      icon: <FaHandHoldingUsd className="text-white text-4xl mb-4" />,
    },
    {
      title: "Cepat, Aman, dan Transparan",
      desc: "Semua informasi kami sajikan secara jelas dan jujur, agar Anda bisa mengambil keputusan finansial dengan tenang.",
      icon: <FaLightbulb className="text-white text-4xl mb-4" />,
    },
  ];

  const reason = [
    {
      title: "Kurasi Mitra Terpercaya",
      desc: "Kami hanya bermitra dengan institusi keuangan legal dan berizin.",
      img: notes,
    },
    {
      title: "Solusi yang Dipersonalisasi",
      desc: "Algoritma cerdas kami mencocokkan solusi sesuai kebutuhan dan profil Anda.",
      img: cup,
    },
    {
      title: "Pengalaman Pengguna yang Nyaman",
      desc: "Desain platform yang intuitif dan ramah pengguna.",
      img: globe,
    },
  ];

  const faqs = [
    {
      question: "Apa itu TOMI Indonesia?",
      answer:
        "Tomi Indonesia adalah sebuah platform aggregator yang menghubungkan pengguna dengan solusi keuangan terbaik di berbagai sektor serta memudahkan akses dan pilihan bagi konsumen di era digital saat ini.",
    },
    {
      question: "Bagaimana cara mendaftar dan menggunakan TOMI?",
      answer:
        "Anda dapat mendaftar di TOMI dengan klik tombol Download di bagian atas halaman website. Setelah instalasi, klik 'Daftar' dan ikuti instruksi untuk membuat akun. Setelah terdaftar, Anda bisa mulai menggunakan aplikasi TOMI sesuai dengan kebutuhan Anda.",
    },
    {
      question: "Apakah data saya aman di aplikasi TOMI?",
      answer:
        "Keamanan data Anda adalah prioritas utama kami. TOMI menggunakan enkripsi canggih untuk melindungi data Anda dan memastikan semua informasi disimpan dengan aman.",
    },
    {
      question: "Bagaimana cara menghubungi dukungan pelanggan TOMI?",
      answer:
        "Anda dapat menghubungi dukungan pelanggan kami melalui email di cs@tokomikro.id atau menggunakan fitur live chat melalui WhatsApp kami di 0811-1118-8188.",
    },
  ];

  return (
    <>
      <main>
        {/* HERO */}
        <Hero
          title="Semua Solusi Kebutuhan Dalam Satu Platform"
          subtitle="Dari pinjaman hingga investasi. Tomi Indonesia hadir sebagai partner keuangan tepercaya untuk individu, UMKM, hingga korporasi."
          buttonText="Download Sekarang"
          buttonLink={`${process.env.REACT_APP_API_URL}/download/aplikasi/tomi-101.apk`}
          variant="secondary"
          align="left"
          imageHero={mobileHero}
        />

        {/* SECTION: Menghubungkan Anda */}
        <section className="section-shell section-band">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-12 text-center">
              <span className="section-eyebrow mb-3">Keunggulan Tomi</span>
              <h2 className="section-title mx-auto max-w-3xl">
                Menghubungkan Anda dengan masa depan yang lebih baik
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
              {reason.map((item, index) => (
                <div
                  key={index}
                  className="modern-card group flex items-start gap-5 p-6 lg:p-7"
                >
                  <img
                    src={item.img}
                    alt={item.title}
                    className="h-14 w-14 rounded-2xl bg-blue-50 p-2 object-contain transition-transform duration-300 group-hover:scale-110"
                  />
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="section-copy">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SECTION: Why Choose Us */}
        <section className="section-shell bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="section-title mb-3">
                Why Choose Us
              </h2>
              <p className="section-copy max-w-xl mx-auto">
                Mengapa Ribuan Pengguna Memilih Tomi Indonesia?
              </p>
            </div>

            <div className="relative overflow-hidden rounded-3xl bg-[#3f6fe5] p-8 shadow-2xl shadow-[#3f6fe5]/20 sm:p-12 lg:p-16">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 text-center text-white">
                {whyChooseUs.map((item, i) => (
                  <div
                    key={i}
                    className="relative flex flex-col items-center px-4 py-3 transition-all duration-300 hover:-translate-y-1"
                  >
                    {item.icon}
                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                      {item.title}
                    </h3>
                    <p className="text-sm leading-relaxed text-blue-100 sm:text-base">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* SECTION: FAQ */}
        <section className="section-shell section-band">
          <div className="max-w-4xl mx-auto px-4">
            <div className="mb-12 text-center">
              <span className="section-eyebrow mb-3">FAQ</span>
              <h2 className="section-title mb-4">
                Pertanyaan yang Sering Diajukan
              </h2>
              <p className="section-copy">
                Cari tahu informasi mengenai Tomi Indonesia
              </p>
            </div>
            <div className="space-y-4">
              {faqs.map((faq, i) => (
                <div
                  key={i}
                  className="modern-card overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                    className="w-full flex justify-between items-center gap-4 text-left p-5 sm:p-6 font-semibold text-slate-800 focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-blue-100"
                  >
                    {faq.question}
                    <span
                      className={`flex-shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-[#eef4ff] text-[#3f6fe5] text-xl transition-transform duration-300 ${
                        openIndex === i ? "rotate-45" : ""
                      }`}
                    >
                      +
                    </span>
                  </button>
                  {openIndex === i && (
                    <div className="px-5 sm:px-6 pb-6 text-slate-600 leading-relaxed text-sm sm:text-base">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SECTION: Mitra Kami */}
        <section className="section-shell bg-white border-y border-slate-100">
          <div className="container mx-auto px-4 text-center">
            <h2 className="section-title mb-12">
              Mitra Kami
            </h2>
            <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8 sm:gap-x-16 lg:gap-x-24">
              {mitraLogos.map((logo, i) => (
                <div key={i} className="flex h-24 min-w-40 justify-center items-center">
                  <img
                    src={logo}
                    alt={`Mitra ${i + 1}`}
                    className="h-16 sm:h-20 w-auto mx-auto object-contain transition-all duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default HomePage;
